import { render, staticRenderFns } from "./DocTemplateDetail.vue?vue&type=template&id=5e2b7b26&"
import script from "./DocTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./DocTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocTemplateDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocTemplateDetail.vue"
export default component.exports